// Single source of truth for "is this an Upgraded team member?".
// Team members sign in on either corporate domain, and Clerk accounts often carry
// the work address as a secondary email, so never rely on the primary address alone.
export const ADMIN_EMAIL_DOMAINS = ['getupgraded.ca', 'getupgraded.ai'];

const normalize = (value) => String(value || '').trim().toLowerCase();

export function isAdminDomain(domain) {
  return ADMIN_EMAIL_DOMAINS.includes(normalize(domain).replace(/^@/, ''));
}

// Accepts a full email address or a bare domain (Airtable stores users.Domain).
export function isAdminEmail(email) {
  const value = normalize(email);
  if (!value) return false;
  return isAdminDomain(value.includes('@') ? value.split('@').pop() : value);
}

export function getAdminEmailFromUser(user) {
  if (!user) return null;
  const candidates = [
    user.primaryEmailAddress?.emailAddress,
    ...(user.emailAddresses || []).map((address) => address?.emailAddress),
  ];
  return candidates.find((email) => isAdminEmail(email)) || null;
}

export function isAdminUser(user) {
  return Boolean(getAdminEmailFromUser(user));
}
